module.exports = __webpack_public_path__ + "static/media/icon_logo_png.c4148133.png";